import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ContractorCardsDownloadButtonProps {
  onDownload: () => void;
  disabled: boolean;
  showTooltip?: boolean;
}

export function ContractorCardsDownloadButton({
  onDownload,
  disabled,
  showTooltip = false,
}: ContractorCardsDownloadButtonProps) {
  const { t } = useTranslation();

  const button = (
    <Button
      variant="outline"
      size="sm"
      disabled={disabled}
      onClick={onDownload}
      className={showTooltip ? "!pointer-events-auto" : undefined}
    >
      <Download className="mr-2 h-4 w-4" />
      {t("contractorCards.buttons.downloadSelected")}
    </Button>
  );

  if (!showTooltip) {
    return button;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{button}</TooltipTrigger>
        <TooltipContent>
          <p>{t("contractorCards.buttons.downloadSelectedTooltip")}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
